import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { getPpmHistoryPVDataTableStructure } from './utils/ppm-history.data-table';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { DataTableRowActions, DynamicDataTable } from '../../../components/data-table-builder/data-table.types';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { DialogObject } from '../../../components/dialog/dialog.types';
import { MessageService } from 'primeng/api';
import { PpmRepository } from '../../../store/ppm-state/ppm-state.repository';

@Component({
  selector: 'sm-ppm-history',
  templateUrl: './history-pv.component.html',
  styleUrl: './history-pv.component.scss',
  imports: [PageHeaderComponent, DataTableBuilderComponent, ButtonModule],
})
export class PpmHistoryPVComponent implements OnInit {
  ppmRepository = inject(PpmRepository);
  messageService = inject(MessageService);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'Historique PV',
      routerLink: ['/ppm-history'],
    },
  ];

  loading = true;

  @ViewChild('filter') filter!: ElementRef;

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  ppmDialog?: DialogObject;

  rowActions: DataTableRowActions = {
    inspectAction: row => {
      console.log('Inspecting row:', row);
    },
    editAction: row => {
      console.log('Editing row:', row);
    },
    deleteAction: row => {
      console.log('Deleting row:', row);
    },
  };

  data: any[] = [];
  datatableObject: DynamicDataTable = getPpmHistoryPVDataTableStructure({
    store: this.ppmRepository,
    rowActions: this.rowActions,
  });

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.data = [
      {
        ref: 'PPM-001',
        nom: 'Commission Technique',
        status: 'Validé',
        metadata: {
          createdAt: '2025-06-20T14:30:00Z',
        },
      },
      {
        ref: 'PPM-002',
        nom: 'Commission Financière',
        status: 'En attente',
        metadata: {
          createdAt: '2025-06-19T09:15:00Z',
        },
      },
      {
        ref: 'PPM-003',
        nom: 'Commission RH',
        status: 'Rejeté',
        metadata: {
          createdAt: '2025-06-18T17:45:00Z',
        },
      },
    ];
    this.loading = false;
  }

  redirectNewPpmNotice() {
    this.router.navigate(['/ppm-new-plan']);
  }
}
